import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { Typography } from "@mui/material";
import QuestionnaireCRUDTable from "../../components/CRUD/Tables/QuestionnaireCRUDTable";

const QuestionnaireResponses = () => {
    return (
        <DashboardLayout>
            <Typography variant="h4" component="h1" gutterBottom>
                IQLS - Вопросники
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Просмотр вопросников с ответами, заполненных в мобильном приложении. Каждый вопросник содержит формы и ответы с разделами, вопросами и процентными итогами по каждому разделу.
            </Typography>
            <QuestionnaireCRUDTable />
        </DashboardLayout>
    );
};

export default QuestionnaireResponses;
